/**
 * GeChiUI dependencies
 */
import { createContext } from '@gechiui/element';

const ToolbarContext = createContext();

export default ToolbarContext;
